(function() {
    'use strict';
    /*
     * Copyright (c) 2019-20 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('episodeTypeGlance', EpisodeTypeGlance);

    /**
     * A directive for displaying and editing episode type information as well as custom attribute values on a glance page
     * (e.g. episode or campaign episode template glance).
     *
     * @ngdoc directive
     * @name episode-type-glance
     * @memberOf therapist
     * @example
     * <episode-type-glance
            edit-flag="glanceForm.isEditing"
            episode-object="episode"
            episode-object-edit="episodeVm.episodeTemp">
     * </episode-type-glance>
     */
    function EpisodeTypeGlance() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf therapist.episode-type-glance
                 */
                editFlag: '=',

                /**
                 * The object that contains the episode type and custom values in view mode.
                 * @ngdoc property
                 * @name episode-object
                 * @memberOf therapist.episode-type-glance
                 */
                episodeObject: '=',

                /**
                 * The object that contains the episode type and custom values in edit mode.
                 * @ngdoc property
                 * @name episode-object-edit
                 * @memberOf therapist.episode-type-glance
                 */
                episodeObjectEdit: '=',

                /**
                 * Indicates whether the directive is applied to an episode template, and so does not handle the tracked
                 * measure, the next change measure, or the workflow complete measure.
                 *
                 * @ngdoc property
                 * @name is-episode-template
                 * @memberOf therapist.episode-type-glance
                 */
                isEpisodeTemplate: '='
            },
            controller: 'EpisodeTypeGlanceCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'episode-type-glance/episode-type-glance.tpl.html'
        };
    }
})();